
import { defineComponent } from 'vue'
import { logout } from '@/auth'
import { useI18n } from 'vue-i18n'
import HeaderDropdownAvatar from '@/components/HeaderDropdownAvatar.vue'

export default defineComponent({
  components: { HeaderDropdownAvatar },

  setup() {
    const { t } = useI18n()
    return { logout, t }
  },
})
